import type { ReactNode } from "react";

export function InfoRow({ label, value }: { label: string; value?: string | null }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-2 border-b border-background-200 py-2.5 last:border-0">
      <dt className="text-xs font-label uppercase tracking-wide text-foreground-500">{label}</dt>
      <dd className="max-w-[62%] break-words text-right text-sm font-medium text-foreground-900">
        {value && String(value).trim() ? value : "—"}
      </dd>
    </div>
  );
}

export function DetailSection({
  title,
  icon,
  children,
  action,
}: {
  title: string;
  icon: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 text-sm font-heading font-semibold text-foreground-950">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className={`${icon} text-base leading-none`} aria-hidden="true"></i>
          </span>
          {title}
        </h3>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Chip({ children, tone = "secondary" }: { children: ReactNode; tone?: "secondary" | "accent" }) {
  const classes =
    tone === "accent"
      ? "border-accent-200 bg-accent-50 text-accent-900"
      : "border-secondary-200 bg-secondary-50 text-secondary-900";
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-label font-medium ${classes}`}>
      {children}
    </span>
  );
}

export function EmptyLine({ children }: { children: ReactNode }) {
  return <p className="text-sm text-foreground-500">{children}</p>;
}